import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BaseUrl } from "../helper/BaseUrl";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import LazyRecaptcha from "./LazyRecaptcha";
export default function InquiryModal({ show, setShow }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const sourceUrl = typeof window !== "undefined" ? sessionStorage.getItem("source_url") || "" : "";
  const [formData, setFormData] = useState({
    form_type: "contact_form",
    name: "",
    email: "",
    phone: "",
    city: "",
    message: "",
    bin_size: "",
    source_url: sourceUrl,
    current_url: currentUrl,
  })

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      // allow only digits
      const numericValue = value.replace(/\D/g, "");
      setFormData(prev => ({
        ...prev,
        [name]: numericValue
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        source_url: sourceUrl,
        current_url: currentUrl,
        [name]: value
      }));
    }
  };



  const handleCaptcha = (value) => {
    setCaptchaToken(value);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.bin_size) {
      toast.error("Please choose a Service");
      return;
    }

    if (!captchaToken) {
      toast.error("Please complete the CAPTCHA");
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${BaseUrl}/api/contact/store`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.error === false) {
        navigate("/thank-you");
      } else {
        toast.error(result.message)
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong while submitting the form.");
    } finally {
      setLoading(false);
    }
  }
  return (

    <>

      <Modal show={show} onHide={() => setShow(false)} size="md" aria-labelledby="contained-modal-title-vcenter" centered className="enquery-form-pop">
        <Modal.Body>
          <div className="enquiry-form">
            <button type="button" className="close" onClick={() => setShow(false)} >
              <i className="fa-solid fa-xmark"></i>
            </button>
            <div className="row align-items-center">
              <div className="col-sm-12 col-md-6 col-lg-6 ">
                <div className="form-images">
                  <img src="/assets/images/popup-form-img.webp" alt="Conversation" className="img-responsive" loading="lazy" />
                </div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-6">
                <div className="form-wraper">
                  <img src="/assets/images/popup-left-image.webp" alt="Conversation" className="img-responsive left-popup-img" loading="lazy" />
                  <img src="/assets/images/popup-right-image.webp" alt="Conversation" className="img-responsive right-popup-img" loading="lazy" />
                  <div className="heading">Start the Conversation</div>
                  <p>Our team is ready to help you choose the right dumpster for Edmonton jobs.</p>
                  <form onSubmit={handleSubmit} >
                    <div className="row">
                      <div className="col-md-6">
                        <div className={`form-group  ${!formData.name ? "" : "valid"}`}>
                          <input className="form-control" type="text" name="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className={`form-group  ${!formData.phone ? "" : "valid"}`}>
                          <input type="tel" required name="phone" className="form-control" placeholder="Mobile Number" value={formData.phone} onChange={handleChange} maxLength={10}       // maximum digits   minLength={10}       // minimum digits (optional)   pattern="[0-9]*"     // only digits   inputMode="numeric"  // numeric keyboard on mobile
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className={`form-group  ${!formData.email ? "" : "valid"}`}>
                          <input className="form-control" type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className={`form-group  ${!formData.city ? "" : "valid"}`}>
                          <input className="form-control" type="text" name="city" value={formData.city} onChange={handleChange} placeholder="City" required />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <select className="form-control" name="bin_size" value={formData.bin_size} onChange={handleChange} required >
                            <option value="Bin Size Required *">Bin Size Required *</option>
                            <option value="BIN 1: 12 Cubic Yds. (3 Truckloads)">BIN 1: 12 Cubic Yds. (3 Truckloads)</option>
                            <option value="BIN 2: 15 Cubic Yds. (4 Truckloads)">BIN 2: 15 Cubic Yds. (4 Truckloads)</option>
                            <option value="BIN 3: 20 Cubic Yds. (5 Truckloads)">BIN 3: 20 Cubic Yds. (5 Truckloads)</option>
                            <option value="BIN 4: 25 Cubic Yds. (6 Truckloads)">BIN 4: 25 Cubic Yds. (6 Truckloads)</option>
                            <option value="BIN 5: 30 Cubic Yds. (8 Truckloads)">BIN 5: 30 Cubic Yds. (8 Truckloads)</option>
                            <option value="Burn Bin (Acreages Only)">Burn Bin (Acreages Only)</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className={`form-group ${!formData.message ? "" : "valid"}`} >
                          <textarea className="form-control" name="message" value={formData.message} onChange={handleChange} rows={2} placeholder="Your Message" required ></textarea>
                        </div>
                      </div>

                  <div style={{ marginTop: "15px" }}>
                <LazyRecaptcha  sitekey="6LdvXncsAAAAAFQOF8t2OOLY75_sE1Hcb6_mrBQ1"  onChange={handleCaptcha} />
                </div>



                    </div>
                    <div className="btn-section">
                      <button style={{ opacity: loading ? "0.3" : "1" }} disabled={loading} type="submit" className="theme-btn"> {loading ? "Submitting..." : "Send Message"} </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal >
    </>
  );
}
